import { Partner } from '../partners/partner';

export default function LayoutController(
  $scope,
  $state,
  $location,
  DataService,
  RenderService,
  CreativeDemoFactory,
  ExamplesService,
  SettingsService,
  partner,
  CurrentUserService,
  partnerSites,
  SitesService,
  CreativeService,
  CreativeGroupService,
  localStorageService
) {
  let vm = this;

  vm.adTypeTitles = {
    websiteVisit: 'Website Visit Ad',
    instantPlayCard: 'Instant Play Card Ad'
  };

  vm.state = $state;
  vm.scope = $scope;
  vm.dataService = DataService;
  vm.userSignedIn = false;
  vm.userIsAdmin = false;
  vm.renderService = RenderService;
  vm.creativeService = CreativeService;
  vm.creativeDemoFactory = CreativeDemoFactory;
  vm.settingsService = SettingsService;
  vm.examplesService = ExamplesService;
  vm.partner = new Partner(partner);
  vm.settingsService.isWhiteLabel = $location.search().w != null;
  vm.settingsService.deviceType = $location.search().deviceType || 'mobile';
  vm.addCreativeToLocalStorage = addCreativeToLocalStorage;

  SitesService.partnerSites = partnerSites;

  CurrentUserService.get().then(user => {
    vm.userSignedIn = !!user;
    if (vm.userSignedIn) {
      vm.userId = user.id;
      vm.userEmail = user.email;
      vm.userIsAdmin = user.admin;
    }
    return (vm.showMobileNav = true);
  });

  vm.isNavState = navState =>
    vm.state.current.data && vm.state.current.data.navState == navState;

  vm.hideLoginLinks = () =>
    vm.partner.hideLogin && $state.current.data && $state.current.data.shared;

  vm.thumbnailImageFor = id => vm.creativeDemoFactory.getDemo(id).thumbnailUrl;

  vm.isMobilePlacement = () => {
    if (!vm.renderService.site) {
      return false;
    }
    return vm.renderService.site.group === 'mobile';
  };

  vm.goBack = () => window.history.back();

  function addCreativeToLocalStorage() {
    localStorageService.set('reloadStateInfo', {
      creative: CreativeService.creative,
      state: {
        name: $state.current.name,
        params: $state.params
      }
    });

    localStorageService.set('loadFromLocalStorage', true);
    window.location = '/users/sign_in';
  }

  function loadFromLocalStorage() {
    if (localStorageService.get('loadFromLocalStorage')) {
      let storageData = localStorageService.get('reloadStateInfo');

      $state.go(storageData.state.name, storageData.state.params).then(() => {
        CreativeGroupService.setCreativeGroup({
          creativePreviews: [storageData.creative]
        });

        localStorageService.remove('reloadStateInfo');
        localStorageService.remove('loadFromLocalStorage');
      });
    }
  }

  loadFromLocalStorage();

  return vm;
}

LayoutController.$inject = [
  '$scope',
  '$state',
  '$location',
  'DataService',
  'RenderService',
  'CreativeDemoFactory',
  'ExamplesService',
  'SettingsService',
  'partner',
  'CurrentUserService',
  'partnerSites',
  'SitesService',
  'CreativeService',
  'CreativeGroupService',
  'localStorageService'
];
